import React from "react";
import "./Loading.css";
const Loading = () => {
  return <div id="loading"></div>;
};

export default Loading;
